import { render, staticRenderFns } from "./ReportTrainingDurationInDays.vue?vue&type=template&id=2477acc0"
import script from "./ReportTrainingDurationInDays.vue?vue&type=script&lang=ts"
export * from "./ReportTrainingDurationInDays.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports